import type { Contact, Event } from '@conversia/shared-types';
import type { Paginated, ContactWithRelations, ContactDetails } from '@/lib/types';
import type { ConversationWithRelations } from '@/lib/types';
import { api } from './client';

export interface ContactTimeline {
  conversations: ConversationWithRelations[];
  events: Event[];
}

/** Endpoints de contactos (CRM). Prefijo: /api/contacts */

export interface ListContactsParams {
  channelId?: string;
  search?: string;
  blocked?: 'true' | 'false';
  skip?: number;
  take?: number;
}

export interface UpdateContactInput {
  name?: string | null;
  phone?: string;
  blocked?: boolean;
  profileData?: Record<string, unknown>;
}

/**
 * Alta MANUAL de cliente (Fase 1 trabajo manual): nombre + teléfono, sin
 * conversación de WhatsApp. Idempotente: si el teléfono ya existía, el server
 * devuelve el contacto existente con `created: false`.
 */
export const createManualContact = (input: { nombre: string; telefono: string; fuente?: string }) =>
  api.post<{ contact: Contact; created: boolean }>('/api/contacts', input);

export const listContacts = (params: ListContactsParams = {}) =>
  api.get<Paginated<ContactWithRelations>>('/api/contacts', { query: params });

export const getContact = (id: string) =>
  api.get<ContactWithRelations>(`/api/contacts/${id}`);

export const getTimeline = (id: string) =>
  api.get<ContactTimeline>(`/api/contacts/${id}/timeline`);

/** Detalles enriquecidos + estadísticas. Resuelve el número best-effort si falta. */
export const getContactDetails = (id: string) =>
  api.get<ContactDetails>(`/api/contacts/${id}/details`);

export const updateContact = (id: string, input: UpdateContactInput) =>
  api.patch<Contact>(`/api/contacts/${id}`, input);

/** «Es personal» (Ola E): el agente no le escribe ni le prepara seguimientos. */
export const marcarPersonal = (id: string, personal: boolean) =>
  api.post<Contact>(`/api/contacts/${id}/personal`, { personal });

export const addNote = (id: string, note: string) =>
  api.post<unknown>(`/api/contacts/${id}/notes`, { note });

export const addTag = (id: string, tagId: string) =>
  api.post<{ success: boolean }>(`/api/contacts/${id}/tags`, { tagId });

export const removeTag = (id: string, tagId: string) =>
  api.del<{ success: boolean }>(`/api/contacts/${id}/tags/${tagId}`);
